var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        reviews: true,
        "full-page-paywall": _vm.forFullPaywall,
        mobile: _vm.isMobile(_vm.$mq),
        "paywall-review-section":
          !_vm.user.is_authenticated || _vm.onTrialPaywall,
        "review-content-trial--experiment": _vm.isExperiment
      }
    },
    [
      _vm.user.is_authenticated &&
      !_vm.onTrialPaywall &&
      !_vm.user.has_current_trial_option
        ? _c(
            "div",
            { staticClass: "review-content" },
            [
              _c("AppRating", {
                attrs: {
                  mobile: _vm.isMobile(_vm.$mq),
                  review: true,
                  forMatureUser: true
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.premiumTestimonials, function(testimonial) {
                  return _c(
                    "blockquote",
                    { key: testimonial.testimonial_id, staticClass: "quote" },
                    [
                      _c("p", [_vm._v('"' + _vm._s(testimonial.text) + '"')]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "b-sprite-paywall-pix-stars-small"
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "cite" }, [
                        _vm._v("- " + _vm._s(testimonial.author))
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "review-content review-content-trial" },
            [
              _c("AppRating", {
                attrs: {
                  mobile: _vm.isMobile(_vm.$mq),
                  review: true,
                  isExperiment: _vm.isExperiment
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "trustpilot-container" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("TrustpilotRating", {
                    staticClass: "review trustpilot-frame",
                    attrs: { isExperiment: _vm.isExperiment }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "testimonials" },
                [
                  !_vm.isExperiment
                    ? _vm._l(_vm.premiumTestimonials, function(testimonial) {
                        return _c(
                          "blockquote",
                          {
                            key: testimonial.testimonial_id,
                            staticClass: "quote"
                          },
                          [
                            _c("span", {
                              staticClass: "b-sprite-paywall-pix-stars-small"
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v('"' + _vm._s(testimonial.text) + '"')
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "cite" }, [
                              _vm._v("— " + _vm._s(testimonial.author))
                            ])
                          ]
                        )
                      })
                    : _c("blockquote", { staticClass: "quote" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", { staticClass: "cite" }, [
                          _vm._v("— Jacob S., age 24")
                        ])
                      ]),
                  _vm._v(" "),
                  _vm._m(2)
                ],
                2
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          “Through its engaging and well-structured courses, Brilliant has taught me mathematical\n          concepts that I previously struggled to understand.\n          "
      ),
      _c("b", [
        _vm._v(
          "I now feel confident approaching both technical job interviews and real-world problem\n            solving situations."
        )
      ]),
      _vm._v("”\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep" }, [_c("hr")])
  }
]
render._withStripped = true

export { render, staticRenderFns }